import React from 'react';
import { routes } from '../../data/routes';
import { userStore } from '../../stores/UserStore';
import { NavigateTo } from '../shared/NavigateTo';
import { Game } from './Game';
export const PlayCodeRoute = () => {
  if (!userStore.isWorkshopPlayer) return /*#__PURE__*/React.createElement(NavigateTo, {
    to: routes.home
  });
  return /*#__PURE__*/React.createElement(Game, null);
};